module.exports = __webpack_public_path__ + "static/media/Icon_Chevron.74236ab6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_Chevron.svg
// module id = 2310
// module chunks = 0